module.exports = "../../app/cells/components/campaigns/widgets/offer_label_cell.rb";